import React, { useMemo, useState } from 'react'

import { graphql } from 'gatsby'
import 'keen-slider/keen-slider.min.css'
import { useKeenSlider } from 'keen-slider/react'

import Img from '../components/Img'
import Label from '../components/Label'
import Pagination from '../components/slider/Pagination'

import { useMatchMedia } from '../hooks/useMatchMedia'

const CutureSection = ({ slice }) => {
  const { primary, items } = slice

  const { isMatching, calculated } = useMatchMedia('(max-width:768px)', true)

  const [loaded, setLoaded] = useState(false)
  const [currentSlide, setCurrentSlide] = useState(0)
  const memoOptions = useMemo(
    () => ({
      initial: 0,
      loop: true,
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel)
      },
      created() {
        setLoaded(true)
      },
      slides: {
        perView: 1,
        spacing: 20,
      },
    }),
    [],
  )

  const [sliderRef, instanceRef] = useKeenSlider(memoOptions)

  return (
    <section className={`section culture-section`}>
      <div className="container">
        <div className="align-center">
          <Label text={primary?.label?.text} />
          <h2 className="title">{primary?.title1.text}</h2>
        </div>
        <div className="slider-wrapper">
          <div ref={sliderRef} className="keen-slider">
            {items.map((item) => (
              <div key={item} className="keen-slider__slide slide">
                <Img
                  image={item?.slide_image.gatsbyImageData}
                  alt={item?.slide_image.alt}
                  className="slide-image"
                  objectFit="cover"
                />
                <div className="slide-info">
                  <h3 className="slide-title">{item?.slide_title.text}</h3>
                  <p className="p p-18">{item?.slide_description.text}</p>
                </div>
              </div>
            ))}
          </div>
          <Pagination
            loaded={loaded}
            instanceRef={instanceRef}
            items={items}
            currentSlide={currentSlide}
            showDots={isMatching && calculated}
          />
        </div>
      </div>
    </section>
  )
}

export default CutureSection

export const query = graphql`
  fragment CareersPageDataBodyCultureSection on PrismicCareersPageDataBodyCultureSection {
    id
    slice_type
    items {
      slide_title {
        text
      }
      slide_image {
        gatsbyImageData
        alt
      }
      slide_description {
        text
      }
    }
    primary {
      label {
        text
      }
      title1 {
        text
      }
    }
  }
`
